export const backupTypes = {
    SELECTED_BACKUP: 'SELECTED_BACKUP',
}
